
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.6 6.4a3.2 3.2 0 00-3.2 3.2v12.8a3.2 3.2 0 003.2 3.2h12.8a3.2 3.2 0 003.2-3.2v-4a.8.8 0 111.6 0v4a4.8 4.8 0 01-4.8 4.8H9.6a4.8 4.8 0 01-4.8-4.8V9.6a4.8 4.8 0 014.8-4.8h4a.8.8 0 110 1.6h-4zm8-.8a.8.8 0 01.8-.8h8a.8.8 0 01.8.8v8a.8.8 0 01-1.6 0V7.533l-6.634 6.635a.801.801 0 01-1.132-1.133l6.635-6.633H18.4a.8.8 0 01-.8-.8z","fill":"currentColor"}})])
          )
        }
      }
    